import moment from 'moment';

const getUtcOffset = date => {

    let offset;

    offset = 0;

    if (moment(date).utcOffset()) {

        offset = moment(date).utcOffset();

    }

    return offset;

};

export const getReimbursementSummaryPostingDateValues = {
    MTD: fromToday => ({
        postingDateFrom: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .startOf('month')
            .valueOf(),
        postingDateTo: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .endOf('day')
            .valueOf()
    }),
    PM: fromToday => ({
        postingDateFrom: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .subtract(1, 'months')
            .startOf('month')
            .valueOf(),
        postingDateTo: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .subtract(1, 'months')
            .endOf('month')
            .valueOf()
    }),
    R12M: fromToday => ({
        postingDateFrom: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .startOf('day')
            .subtract(1, 'year')
            .valueOf(),
        postingDateTo: moment(fromToday)
            .add(getUtcOffset(fromToday), 'minutes')
            .utc()
            .endOf('day')
            .valueOf()
    })
};

export const computeTotals = leadAccounts => leadAccounts.reduce((currentTotals, currentLeadAccount) => ({
    ...currentTotals,
    totalApproved: currentTotals.totalApproved + currentLeadAccount.totalApproved,
    totalRequested: currentTotals.totalRequested + currentLeadAccount.totalRequested,
    totalUnpaid: currentTotals.totalUnpaid + currentLeadAccount.totalUnpaid
}), {
    totalApproved: 0,
    totalRequested: 0,
    totalUnpaid: 0
});

const round = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals); // eslint-disable-line prefer-template

export const computeTotalRecoveryPercentage = (totalApproved, totalRequested) => round((totalApproved * 100) / totalRequested, 2);

export const displayIconForRecoveryPercentage = (totalRecoveryPercentage, {yellow, red}) => {

    if (totalRecoveryPercentage <= yellow && totalRecoveryPercentage > red) {

        return 'dot-icon-yellow';

    } else if (totalRecoveryPercentage <= red) {

        return 'dot-icon-red';

    }

    return '';

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/helpers.js